import { CAZA, SENDA } from '@somnhold/content';
import type { PensRules, TrailRules } from '../caza-types.ts';
import type { PensLayout, TrailLayout } from './caza-layout.ts';

/**
 * The Long Hunt's rules from their layouts (docs/sendas/barbaro.md, chapter 1): the fight's builder (campaign/sendas.ts)
 * and the renderer's scenes build them the same way. CAZA.pens, trail, howler and stone; lives in hit points worked
 * out by the caller (seconds of D).
 */

export const pensRules = (L: PensLayout, wolfHp: number): PensRules => {
  const P = CAZA.pens;
  return {
    homes: L.homes.map((p) => ({ ...p })),
    rim: L.rim.map((p) => ({ ...p })),
    wall: L.wallAt.map((p) => ({ ...p })),
    gate: { ...L.gateAt },
    grayIn: { ...L.grayIn },
    grayOut: { ...L.grayOut },
    wolfHp,
    first: P.first,
    every: [P.every[0], P.every[1]],
    band: [P.band[0], P.band[1]],
    grab: P.grab,
    twoBp: P.twoBp,
    drag: P.drag,
    reach: P.reach,
    home: P.home,
    need: P.need,
    keep: P.keep,
    grayAt: P.grayAt,
    gray: P.gray,
    crows: { ...P.crows },
  };
};

export const trailRules = (L: TrailLayout, wolfHp: number, howlerHp: number, stoneHit: number): TrailRules => {
  const T = CAZA.trail;
  const A = L.kind === 'tracks' ? T.tracks : T.brink;
  const B = L.kind === 'brink' ? T.brink : null;
  const H = CAZA.howler;
  const S = CAZA.stone;
  return {
    kind: L.kind,
    crossings: L.crossings.map((c) => ({ ...c, at: { ...c.at }, branches: c.branches.map((b) => ({ ...b, pts: b.pts.map((p) => ({ ...p })) })), stream: c.stream.map((p) => ({ ...p })) })),
    end: { ...L.end },
    near: T.near,
    slack: T.slack,
    see: T.see,
    sniff: T.sniff,
    reach: T.reach,
    terronPace: SENDA.npc.speed,
    ambush: A.ambush,
    wolfHp,
    wash: L.crossings.map((_, i) => A.first + A.per * i),
    terronWolves: B ? B.terronWolves : 0,
    ...(B
      ? {
          band: { first: B.band.first, every: [B.band.every[0], B.band.every[1]] as [number, number], n: [B.band.n[0], B.band.n[1]] as [number, number], at: [B.band.at[0], B.band.at[1]] as [number, number] },
          crows: { ...B.crows },
          howler: { hp: howlerHp, biteBp: H.biteBp, reload: H.reload, reach: H.reach, every: H.every, first: H.first, rear: H.rear, howl: H.howl, cutBp: H.cutBp, stun: H.stun, raise: H.raise, healBp: H.healBp, bites: H.bites, back: H.back, keep: H.keep },
          stones: L.stones.map((p) => ({ ...p })),
          stone: { stand: S.stand, reach: S.reach, roll: S.roll, speed: S.speed, width: S.width, hit: stoneHit, stun: S.stun },
        }
      : {}),
  };
};
